import { StyledUIList, StyledHorizontalBreak, StyledUIButton, StyledDataTokenInfo } from 'automation-ui-formula-editor/data-passing-panel/Inputs/DataPropertyPopoverMenu/DataTokenStyle';
import I18n from 'I18n';
import { DATA_TOKEN_POPOVER_DATA_ATTR } from 'automation-ui-formula-editor/data-passing-panel/utils/isClickEventFrom';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataTokenPopover = ({
  DataTokenInfoContent,
  onClickRemoveToken,
  onClickScrollToToken,
  onClickSearchForToken
}) => {
  return /*#__PURE__*/_jsxs("div", {
    [DATA_TOKEN_POPOVER_DATA_ATTR]: '',
    children: [DataTokenInfoContent && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledDataTokenInfo, {
        children: /*#__PURE__*/_jsx(DataTokenInfoContent, {})
      }), /*#__PURE__*/_jsx(StyledHorizontalBreak, {})]
    }), /*#__PURE__*/_jsxs(StyledUIList, {
      children: [onClickScrollToToken && /*#__PURE__*/_jsx(StyledUIButton, {
        use: "unstyled",
        onClick: () => onClickScrollToToken(),
        children: I18n.text('automation-ui-formula-editor.data-passing-panel.data-token-popover.scroll-to-button.label')
      }), onClickSearchForToken && /*#__PURE__*/_jsx(StyledUIButton, {
        use: "unstyled",
        onClick: () => onClickSearchForToken(),
        children: I18n.text('automation-ui-formula-editor.data-passing-panel.data-token-popover.search-for-token-button.label')
      }), onClickRemoveToken && /*#__PURE__*/_jsx(StyledUIButton, {
        use: "unstyled",
        onClick: () => onClickRemoveToken(),
        children: I18n.text('automation-ui-formula-editor.data-passing-panel.data-token-popover.remove-token-button.label')
      })]
    })]
  });
};
export default DataTokenPopover;